export const COMMENTS_RAIL_WIDTH_PX = 340;
export const COMMENTS_RAIL_TRANSITION = 'flex-basis 0.2s ease-out, width 0.2s ease-out';
